module.exports = __webpack_public_path__ + "img/cancun.c3ef964a.png";